import axios from "axios";

import { ENDPOINTS } from "../jsx/services/ENDPOINT";


const STOCK_API = `${ENDPOINTS.BASE_2}/stock`;
// ================= STOCK APIs =================

export const createNewStock = (data) => {
  return axios.post(`${STOCK_API}/create`, data);
};

export const getStockByDrink = (drinkId) =>
  axios.get(`${STOCK_API}/${drinkId}`);

export const updateStock = (id, data) => {
  return axios.put(`${STOCK_API}/${id}`, data);
};

export const deleteStock = (id) => {
  return axios.delete(`${STOCK_API}/${id}`);
};

export const addStock = (data) => {
  return axios.post(`${STOCK_API}`, data);
};

export const getStockReport = (params) => {
  return axios.get(`${STOCK_API}/report`, { params });
};